export default __webpack_public_path__ + "static/media/ProCal-logo.9bd29aac.svg";